import Vue from 'vue'
import router from './router'
import App from './App.vue'
import '@/plugins/element.js'
import './assets/css/global.scss'
import 'element-ui/lib/theme-chalk/index.css';
// import './assets/fonts/iconfont.css'

import './assets/css/tailwind.css'
// import Vue from 'vue';
// import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/swiper-bundle.css';
// Vue.use(Swiper)

import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
// 引入语言资源文件
import en from '@/lang/en.js';
import zh from '@/lang/zh.js';

Vue.use(ElementUI);
Vue.use(VueI18n);

// 仅在后台管理路径 /RTS/KLM/ 下显示 Element UI Message 消息提示
const ADMIN_PATH_PREFIX = '/RTS/KLM/'
const isAdminRoute = () => window.location.pathname.startsWith(ADMIN_PATH_PREFIX)
const originalMessage = Vue.prototype.$message
Vue.prototype.$message = function (...args) {
  if (isAdminRoute()) {
    return originalMessage.apply(this, args)
  }
}
;['success', 'error', 'warning', 'info'].forEach((type) => {
  const original = originalMessage[type]
  if (original) {
    Vue.prototype.$message[type] = function (...args) {
      if (isAdminRoute()) {
        return original.apply(this, args)
      }
    }
  }
})

// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale:  'zh',
  messages: {
    en: en,
    zh: zh
  }
});


// main.js
const resizeObserverErrHandler = (err) => {
  if (err.message.includes('ResizeObserver')) return;
  console.error(err);
};
window.addEventListener('error', resizeObserverErrHandler);


// 路由守卫：从 URL ?lang= 参数同步语言
router.beforeEach((to, from, next) => {
  const lang = to.query.lang
  if (lang === 'en' || lang === 'zh') {
    i18n.locale = lang
    window.sessionStorage.setItem('sessionLang', lang)
    next()
  } else if (!lang) {
    const saved = window.sessionStorage.getItem('sessionLang') || 'zh'
    next({ path: to.path, query: { ...to.query, lang: saved }, replace: true })
  } else {
    next()
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
